import {EFormFieldWatcherConnective} from 'shared/constants/watchers';
import {IFormFieldWatcher} from 'shared/types/watchers';

export const createConnectiveJoiner = (
    connective: IFormFieldWatcher['conditions'][0]['withConnective'],
) => (a: boolean, b: boolean) => {
    if (!connective) return a && b;
    if (connective === EFormFieldWatcherConnective.AND) return a && b;
    if (connective === EFormFieldWatcherConnective.AND_NOT) return a && !b;
    if (connective === EFormFieldWatcherConnective.OR_NOT) return a || !b;
    if (connective === EFormFieldWatcherConnective.OR) return a || b;
    return a || b;
};